import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { Accordion } from '@contrast-security-inc/design-system-surfaces'
import { Text } from '@contrast-security-inc/design-system-typography'

const accordionCss = css`
  width: 100%;
`
const stepNumberCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.color.turquoise90};
  border-radius: 50%;
  color: ${theme.color.white};
  height: 28px;
  width: 28px;
  align-self: start;
  margin-top: 10px;
  margin-right: 4px;
`
const titleContentCss = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const getDefaultIsOpen = (defaultIsOpen?: boolean): boolean => {
  if (defaultIsOpen !== undefined) {
    return defaultIsOpen
  }

  return true
}

export const AgentWizardStepContainer = ({
  number = 1,
  step: { titleMsg, TitleContent = null, defaultIsOpen },
  enableScrollToContent = false,
  children
}: {
  number?: number
  step: {
    titleMsg: string
    // i hate ts so much
    TitleContent?: (() => React.ReactElement) | null
    defaultIsOpen?: boolean
  }
  enableScrollToContent?: boolean
  children: React.ReactNode
}) => {
  const intl = useIntl()
  const contentRef = React.useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = React.useState(getDefaultIsOpen(defaultIsOpen))

  // below .ds-accordion rules fix a bug in skeletor accordion
  // that doesnt set the width of the title it warps with a Text component
  // this is a temp workaround until we fix the accordion to allow full size titles
  return (
    <div
      ref={contentRef}
      data-testid={`agent-wizard-step-container`}
      className={css`
        display: flex;
        flex-direction: row;
        width: 100%;
        padding-bottom: 8px;
        margin-bottom: 32px;
        & .ds-accordion > div > span.ds-text {
          width: 100%;
        }
      `}
    >
      <div className={stepNumberCss}>
        <Text font="body">{number}</Text>
      </div>
      <Accordion
        className={accordionCss}
        arrowPlacement="left"
        showBorder={false}
        title={
          <Text
            font="titleH2"
            className={TitleContent ? titleContentCss : undefined}
          >
            {intl.formatMessage({ id: titleMsg })}
            {TitleContent && <TitleContent />}
          </Text>
        }
        setIsOpen={() => {
          setIsOpen(!isOpen)
          if (!isOpen && enableScrollToContent) {
            setTimeout(() =>
              contentRef?.current?.scrollIntoView({ behavior: 'smooth' })
            )
          }
        }}
        isOpen={isOpen}
      >
        {/** why is this rendering the content when it isn't open? */}
        {() => isOpen && <Text font="body">{children}</Text>}
      </Accordion>
    </div>
  )
}
